<template>
    <div class="iu-split-panel-wrapper">
        <div class="iu-split-panel" ref="splitpanel">
            <div class="pane" v-bind:style="{ [dimension]: `${currentPos}%` }">
                <slot name="a"></slot>
            </div>
            <div class="pane" v-bind:style="{ [dimension]: `${100 - currentPos}%` }">
                <slot name="b"></slot>
            </div>

            <div
                v-if="!fixed"
                v-bind:class="[type, 'divider']"
                v-bind:style="{ [side]: `calc(${currentPos}% - 0px)` }"
                use:drag="{setPos}"
                @mousedown="dragStart"
            ></div>
        </div>
        <div v-if="dragging" class="mousecatcher"></div>
    </div>
</template>

<script>
export default {
    name: 'IuSplitPanel',
    props: {
        fixed: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'horizontal',
        },
        pos: {
            type: Number,
            default: 50,
        },
        min: {
            type: Number,
            default: 50,
        },
    },
    data() {
        return {
            dimension: this.type === 'horizontal' ? 'width' : 'height',
            side: this.type === 'horizontal' ? 'left' : 'top',
            dragging: false,
            currentPos: this.pos,
        };
    },
    methods: {
        dragStart(event) {
            event.preventDefault();
            this.dragging = true;

            window.addEventListener('mousemove', this.dragMove, false);
            window.addEventListener('mouseup', this.dragEnd, false);
        },
        dragMove(event) {
            event.preventDefault();

            if (!this.dragging) return;

            const { top, bottom, left, right } = this.$refs.splitpanel.getBoundingClientRect();
            const extents = this.type === 'vertical' ? [top, bottom] : [left, right];
            const num = this.type === 'vertical' ? event.clientY : event.clientX;
            const minSize = extents[0] + this.min;
            const maxSize = extents[1] - this.min;

            const px = num < minSize ? minSize : num > maxSize ? maxSize : num;
            this.currentPos = (100 * (px - extents[0])) / (extents[1] - extents[0]);
        },
        dragEnd() {
            this.dragging = false;
            window.removeEventListener('mousemove', this.dragMove, false);
            window.removeEventListener('mouseup', this.dragEnd, false);
        },
    },
    mounted() {
        window.addEventListener('mouseup', this.dragEnd);
    },
    computed: {},
};
</script>

<style lang="scss" scope>
.iu-split-panel-wrapper {
    height: 100%;

    .iu-split-panel {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .pane {
        position: relative;
        float: left;
        width: 100%;
        height: 100%;
    }
    .mousecatcher {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.01);
    }
    .divider {
        position: absolute;
        z-index: 10;
        display: none;
    }
    .divider::after {
        content: '||';
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #b3b3b3;
    }
    .horizontal {
        padding: 0 6px;
        width: 1px;
        height: 100%;
        cursor: ew-resize;
    }
    .horizontal::after {
        left: 0px;
        top: 0;
        width: 14px;
        height: 100%;
    }
    .vertical {
        padding: 8px 0;
        width: 100%;
        height: 0;
        cursor: ns-resize;
    }
    .vertical::after {
        top: 8px;
        left: 0;
        width: 100%;
        height: 1px;
    }
    .divider {
        display: block;
    }
}
</style>
